import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { IPublishedNewsResponse, IResidentNewsContent } from '../../models';
import { newsQueryV2, publishedNewsPublicQuery, singleNewsQueryV2 } from '../../queries';

@Injectable()
export class NewsFacade {
  constructor(private apollo: Apollo) {}

  public getNews(offset: number, limit: number): Observable<IPublishedNewsResponse> {
    return this.apollo
      .query<{ publishedNewsV2: IPublishedNewsResponse }>({
        query: newsQueryV2,
        variables: {
          offset,
          limit,
        },
      })
      .pipe(map(response => response?.data?.publishedNewsV2));
  }

  public getSingleNews(newsId: string): Observable<IResidentNewsContent> {
    return this.apollo
      .query<{ getNewsV2: IResidentNewsContent }>({
        query: singleNewsQueryV2,
        variables: {
          newsId,
        },
      })
      .pipe(map(response => response?.data?.getNewsV2));
  }

  public getPublishedNewsPublic(offset: number, limit: number): Observable<IPublishedNewsResponse> {
    return this.apollo
      .query<{ publishedNewsPublic: IPublishedNewsResponse }>({
        query: publishedNewsPublicQuery,
        variables: {
          offset,
          limit,
        },
      })
      .pipe(map(response => response?.data?.publishedNewsPublic));
  }
}
